module.exports = __webpack_public_path__ + "img/bb_g3_nose-06.75ca7074.svg";